import ApiService from '../common/api.service';

import {
  CREATE_AVISO,
  FETCH_AVISOS,
  REMOVE_AVISO,
  LISTAR_SUBCONDOMINIOS_AVISOS, NOTIFICAR_AVISO, OBTENER_ARCHIVO_AVISO,

} from './actions.type';

import {
  SET_ERROR,
  CLEAR_ALERT_DIALOG,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
};

const getters = {
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
};

const actions = {
  [LISTAR_SUBCONDOMINIOS_AVISOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.query('accesos/avisos_subcondominios')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_AVISOS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('accesos/listar_avisos', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [OBTENER_ARCHIVO_AVISO](context, fileName) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.blob(`accesos/aviso_file/${fileName}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [REMOVE_AVISO](context, avisoId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post(`accesos/remove_aviso/${avisoId}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ data }) => {
          context.commit(SET_ERROR, [data.data.message]);
        });
    });
  },
  [NOTIFICAR_AVISO](context, data) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.post('accesos/notificar_aviso', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [CREATE_AVISO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('accesos/agregar_aviso', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alert = false;
    state.alertMessage = '';
    state.alertType = 'success';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
